let format = (value) => {
  return value >= 10 ? value : '0' + value
};
/**
 * 时间格式化
 */
export const date = (time, type) => {
  let result
  if (!time) {
    return result = ''
  }
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let second = date.getSeconds()
  switch (type) {
    case 0: // 01-05
      result = `${format(month)}-${format(day)}`
      break
    case 1: // 11:12
      result = `${format(hours)}-${format(minutes)}`
      break
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`
      break
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`
      break
    case 4: // 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}:${format(second)}`
      break
  }
  return result
};

/**
 * 如果时间格式是返回的是1970-01-01，就返回空
 */
export const dateRes = (time, type) => {
  let result = date(time, type);
  if (result == "1970-01-01  08:00:00" || result == "1970-01-01") {
    return "----";
  } else {
    return result;
  }
};
/**
 * 图片格式化
 */
export const imgUrl = (url) => {
  return 'https://mks.yybip.com/' + url;
};

export const imgToHttps = (content) => {
  return content.replace(/\http:\/\/mk.yybip.com\//g,"https://mks.yybip.com/");
}


/**
 * 图片格式化
 */
export const fileUrl = (url) => {
  if (url) {
    return 'https://mks.yybip.com/' + url;
  } else {
    return ''
  }
};

export const boolToString = (param, code) => {
  if (param != undefined && param != null) {
    if (param === true) {
      return '是';
    } else if (param === false) {
      return '否'
    } else if (param.toString().length == 13 && param.toString().indexOf('+') === -1 && !isNaN(param)) {
      return date(param, 4)
    } else {
      if (code === 'msg_receiveStatus') {
        if(param == 'DELIVRD' || param == 'DELIVERED') {
          return '成功'
        } else {
          return '失败'
        }
      } else {
        return param;
      }
    }
  } else {
    return param;
  }
}

/*
  b装换成M
*/
function toDecimal(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}
export const BToMB = (b) => {
  if (b < 1048576) {
    return toDecimal((b / 1024)) + "kb";
  } else {
    return toDecimal(((b / 1024) / 1024)) + "mb";
  }
}

/*
  根据类型返回汉字
*/
export const naireType = (type) => {
  let result = "";
  switch (type) {
    case 'input':
      result = "单行输入框";
      break;
    case 'textarea':
      result = "多行输入框";
      break;
    case 'radio':
      result = "单选题";
      break;
    case 'checkbox':
      result = "多选题";
      break;
    case 'nps':
      result = "NPS";
      break;
    case 'select':
      result = "下拉框";
      break;
    case 'fen':
      result = "评分题";
      break;
  };
  return result;
}

/**
 * 验证密码
 * 长度为8-18位字符，不能包括空格，必须包含字母、数字、符号中至少2种
 * @param {*} value 输入的值
 */
export const passwordValidation = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入密码"));
  } else {
    if (!/^(?![A-Za-z]*$)(?![0-9]*$)(?![^A-Za-z0-9]*$)\S{8,18}$/.test(value)) {
      callback(new Error('长度为8-18位字符，不能包括空格，必须包含字母、数字、符号中至少2种'))
    } else {
      console.log('验证成功')
    }
    callback();
  }
}

export const cutNameLength = (name) => {
  if (!name) return
  name = name.replace(/(^\s*)|(\s*$)/g, '')
  let reg=/^[\u2E80-\u9FFF]+$/  // Unicode编码中的汉字范围
  if(reg.test(name)){
    return name.substring(name.length-2<0?0:name.length-2,name.length)
  } else {
    return name.substring(name.length-4<0?0:name.length-4,name.length)
  }
}

export const activityStatus = (value) => {
  let tempstr = value
  switch (value) {
    case 0:
      tempstr = '暂存'
      break
    case 1:
      tempstr = '已审核'
      break
    case 2:
      tempstr = '待审核'
      break
    case 3:
      tempstr = '被驳回'
      break
  }
  return tempstr
}